import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from 'material-ui';
import Subheader from 'material-ui/Subheader';
import { connect } from 'react-redux';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import { fetchApp } from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './AddPointPage.css';
import { postPoint } from '../../../store/points/actions';
import PointForm from '../../../components/openexplore/PointForm/PointForm';
import Mapbox from '../../../components/openexplore/Mapbox/Mapbox';
import { getCustomFields } from '../../../store/customfields/actions';
import { getTypes } from '../../../store/types/actions';
import CustomFieldService from '../../../services/customfield';
import { dispatchInfo } from '../../../store/infos/actions';
import { POINT_PAGE } from '../../../constants/routes';

let MapboxClient = require('mapbox');

export class AddPointPage extends React.Component {

    mapboxClient = new MapboxClient('pk.eyJ1IjoiZHJ1c3kiLCJhIjoiY2owYjBlNmhrMDAwdzJxcDloMnJybHd1NyJ9.H256nOJ0yauBFXMZJ9972A');

    static propTypes = {
        app: PropTypes.object,
    };

    static defaultProps = {};

    state = {
        shouldCreateNew: false,
        latlng: null,
        address: null,
    };

    componentWillMount() {
        this.fetchApplication();

        if (this.props.app) {
            this.props.getTypes(this.props.app.id, this.props.lang);
            this.props.getCustomFields(this.props.app.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.app && this.props.app !== nextProps.app) {
            this.props.getTypes(nextProps.app.id, nextProps.lang);
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending && nextProps.point) {

            if (this.state.shouldCreateNew) {
                this.props.dispatchInfo(nextProps.point.name + ' saved');
            }

            if (this.state.latlng && !this.state.shouldCreateNew) {
                let url = POINT_PAGE
                    .replace(':appId', this.props.app.id)
                    .replace(':pointId', nextProps.point.id);
                this.props.history.push(url);
            }
        }

        if (this.state.shouldCreateNew) {
            this.setState({ shouldCreateNew: false });
        }
    }

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        await this.props.postPoint(this.props.app.id, formProps, this.props.lang);
    };

    handleMapClicked = (event) => {
        this.setState({
            latlng: event.latlng,
        });
        this.mapboxClient.geocodeReverse(
            {
                latitude: event.latlng.lat,
                longitude: event.latlng.lng,
            })
            .then(res => {
                if (res.entity.features
                    && res.entity.features.length > 0
                    && res.entity.features[0].place_name) {
                    this.setState({
                        address: res.entity.features[0].place_name,
                    });
                }
            })
            .catch(err => {
                //TODO: handle error
            });
    };

    handleLatChanged = (lat) => {
        let latlng = this.state.latlng;
        let shouldCenter = latlng !== null && latlng.lat !== lat;
        let stateChange;
        if (this.state.latlng !== undefined && this.state.latlng !== null) {
            stateChange = {
                ...this.state.latlng,
                lat: Number.parseFloat(lat),
                shouldCenter: shouldCenter,
            };
        } else {
            stateChange = {
                lat: Number.parseFloat(lat),
                lng: 0.0,
                shouldCenter: shouldCenter,
            };
        }
        this.setState({
            latlng: stateChange,
        });
    };

    handleLngChanged = (lng) => {
        let latlng = this.state.latlng;
        let shouldCenter = latlng !== null && latlng.lng !== lng;
        let stateChange;
        if (this.state.latlng !== undefined && this.state.latlng !== null) {
            stateChange = {
                ...this.state.latlng,
                lng: Number.parseFloat(lng),
                shouldCenter: shouldCenter,
            };
        } else {
            stateChange = {
                lat: 0.0,
                lng: Number.parseFloat(lng),
                shouldCenter: shouldCenter,
            };
        }
        this.setState({
            latlng: stateChange,
        });
    };

    handleAddressChanged = address => {
        this.setState({
            address: address,
        });
    };

    handleFindAddress = address => {

        this.mapboxClient.geocodeForward(address)
            .then(res => {
                if (res.entity.features
                    && res.entity.features.length > 0
                    && res.entity.features[0].center
                    && res.entity.features[0].center.length === 2) {
                    const center = res.entity.features[0].center;
                    this.setState({
                        latlng: {
                            lat: Number.parseFloat(center[1]),
                            lng: Number.parseFloat(center[0]),
                            shouldCenter: true,
                        },
                    });
                }
            })
            .catch(err => {
                console.log(err);
                this.props.dispatchInfo('Could not geocode address: ' + address);
            });
    };

    handleFormReset = () => {
        this.setState({
            latlng: null,
            address: null,
            shouldCreateNew: true,
        });
    };

    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>
                        Point / Add - {this.props.app.name}
                    </h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper>
                                <Subheader style={style.subHeader}>
                                    Map
                                </Subheader>
                                <Mapbox
                                    latlng={this.state.latlng}
                                    onMapClicked={this.handleMapClicked}
                                    canShowDetail={false}
                                    showPopups={false}
                                    points={[]}
                                    trails={[]}
                                    style={styles.map}
                                    mapStyle={this.props.mapStyle}
                                />
                            </Paper>
                        </div>
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>
                                    New point
                                </Subheader>
                                <div style={style.paper}>
                                    <PointForm
                                        customFields={
                                            CustomFieldService.filter(
                                                this.props.customFields,
                                                CustomFieldService.OPEN_EXPLORE_POINT,
                                            )
                                        }
                                        types={this.props.types}
                                        onFormReset={this.handleFormReset}
                                        onLatChanged={this.handleLatChanged}
                                        onLngChanged={this.handleLngChanged}
                                        onFindAddress={this.handleFindAddress}
                                        onAddressChanged={this.handleAddressChanged}
                                        latlng={this.state.latlng}
                                        address={this.state.address}
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.sending}
                                    />
                                </div>
                                <div style={style.clear} />
                            </Paper>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apps.pending
            || state.points.pending
            || state.types.pending
            || state.customFields.pending,
        error: state.apps.error,
        point: state.points.currentPoint,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.points.sending,
        mapStyle: state.ui.mapStyle,
        types: state.types.content,
        customFields: state.customFields.content,
    };
}

export default connect(mapStateToProps, {
    getTypes,
    getCustomFields,
    postPoint,
    fetchApp,
    dispatchInfo,
})(AddPointPage);



// WEBPACK FOOTER //
// src/containers/openexplore/AddPointPage/AddPointPage.js